import { Suspense, lazy } from "react";
import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";

import LoadingSpinner from "./components/LoadingSpinner.tsx";
import { AppLayout } from "./components/layouts/AppLayout";
import { Toaster } from "./ui/sonner.tsx";
import ErrorsRouting from "./components/routing/ErrorsRouting.tsx";
import { EnvironmentBanner } from "./components/common/EnvironmentBanner.tsx";
import { OnboardingStepGuard } from "./components/onboarding/OnboardingStepGuard.tsx";

const OnboardingLayout = lazy(() => import("./pages/onboarding/OnboardingLayout.tsx"));
const OnboardingValidatingPage = lazy(() => import("./pages/onboarding/OnboardingValidatingPage.tsx"));
const OnboardingCompletePage = lazy(() => import("./pages/onboarding/OnboardingCompletePage.tsx"));
const OnboardingTokenRedirect = lazy(() =>
  import("./components/onboarding/OnboardingTokenRedirect.tsx").then((m) => ({
    default: m.OnboardingTokenRedirect,
  })),
);
const BusinessInfoForm = lazy(() => import("./components/onboarding/BusinessInfoForm.tsx"));
const OwnerInfoFormMultiple = lazy(() => import("./components/onboarding/OwnerInfoFormMultiple.tsx"));
const BankAccountForm = lazy(() => import("./components/onboarding/BankAccountForm.tsx"));
const PolicyCollectionForm = lazy(() => import("./components/onboarding/PolicyCollectionForm.tsx"));
const OnboardingReview = lazy(() => import("./components/onboarding/OnboardingReview.tsx"));
const Home = lazy(() => import("./pages/Home.tsx"));
const PaymentIframe = lazy(() => import("./pages/PaymentIframe.tsx"));
const IframeIntegrationDocs = lazy(() => import("./pages/IframeIntegrationDocs.tsx"));
const IframeDemoPage = lazy(() => import("./pages/IframeDemoPage.tsx"));

function App() {
  return (
    <>
      <EnvironmentBanner />
      <Router>
        <Toaster />
        <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          <Route path="/pay" element={<PaymentIframe />} />

          <Route element={<AppLayout />}>
            <Route path="/" element={<Home />} />

            <Route path="/onboarding" element={<OnboardingTokenRedirect />} />
            <Route path="/onboarding/:token" element={<OnboardingLayout />}>
              <Route index element={<Navigate to="validating" replace />} />
              <Route path="validating" element={<OnboardingValidatingPage />} />
              <Route element={<OnboardingStepGuard />}>
                <Route path="business-information" element={<BusinessInfoForm />} />
                <Route path="owner-information" element={<OwnerInfoFormMultiple />} />
                <Route path="bank-account" element={<BankAccountForm />} />
                <Route path="compliance-policies" element={<PolicyCollectionForm />} />
                <Route path="review" element={<OnboardingReview />} />
              </Route>
              <Route path="complete" element={<OnboardingCompletePage />} />
              <Route path="*" element={<Navigate to="validating" replace />} />
            </Route>

            <Route path="/onboarding-success" element={<Navigate to="/" replace />} />

            <Route path="/iframe-integration" element={<IframeIntegrationDocs />} />
            <Route path="/iframe-demo" element={<IframeDemoPage />} />

            <Route path="/error/*" element={<ErrorsRouting />} />
            <Route path="*" element={<ErrorsRouting />} />
          </Route>
        </Routes>
      </Suspense>
    </Router>
    </>
  );
}

export default App;
